<template>
  <div class="modal is-active">
    <div class="modal-background" @click="close"></div>
    <div class="modal-content">
      <div class="box filters-box">
        <h3 class="title is-5">Filtros</h3>

        <div class="columns is-multiline">
          <div class="column is-6">
            <div class="field">
              <label class="label is-small">Estado del producto</label>
              <div class="select is-fullwidth">
                <select v-model="draft.filter">
                  <option value="0">Todos</option>
                  <option value="1">Pendiente</option>
                  <option value="2">Activo</option>
                  <option value="3">Vendido</option>
                  <option value="4">Eliminado</option>
                </select>
              </div>
            </div>
          </div>

          <div class="column is-6">
            <div class="field">
              <label class="label is-small">Tipo de producto</label>
              <div class="select is-fullwidth">
                <select v-model="draft.tradeIn">
                  <option value="todos">Todos</option>
                  <option value="normales">Solo Normales</option>
                  <option value="tradeIn">Solo Trade-In</option>
                </select>
              </div>
            </div>
          </div>

          <div class="column is-12">
            <h4 class="subtitle is-6 section-label">Seguimiento del embudo</h4>
          </div>

          <div class="column is-4">
            <div class="field">
              <label class="label is-small">Estado general</label>
              <div class="select is-fullwidth">
                <select v-model="draft.funnelStatus">
                  <option value="">Todos</option>
                  <option value="none">Sin seguimiento</option>
                  <option
                    v-for="option in overallStatusOptions"
                    :key="option.slug"
                    :value="option.slug"
                  >{{ option.nombre }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="column is-4">
            <div class="field">
              <label class="label is-small">Toques</label>
              <div class="select is-fullwidth">
                <select v-model="draft.funnelTouches">
                  <option value="">Todos</option>
                  <option value="none">Sin toques</option>
                  <option
                    v-for="option in touchOptions"
                    :key="option.slug"
                    :value="option.slug"
                  >{{ option.nombre }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="column is-4">
            <div class="field">
              <label class="label is-small">Motivo de rechazo</label>
              <div class="select is-fullwidth">
                <select v-model="draft.rejectionReason">
                  <option value="">Todos</option>
                  <option value="none">Sin motivo</option>
                  <option
                    v-for="option in rejectionReasonOptions"
                    :key="option.slug"
                    :value="option.slug"
                  >{{ option.nombre }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="column is-12">
            <h4 class="subtitle is-6 section-label">Ubicación</h4>
          </div>

          <div class="column is-6">
            <div class="field">
              <label class="label is-small">Código postal</label>
              <input class="input" v-model="draft.zipCode" placeholder="Código postal...">
            </div>
          </div>

          <div class="column is-6">
            <div class="field">
              <label class="label is-small">Región / Estado</label>
              <v-select
                v-model="draft.region"
                :options="regionOptions"
                :filterable="false"
                placeholder="Región / Estado..."
                @search="onRegionSearch"
              />
            </div>
          </div>
        </div>

        <div class="field is-grouped is-grouped-right mt-4">
          <div class="control">
            <button class="button is-text" @click="clear">Limpiar todo</button>
          </div>
          <div class="control">
            <button class="button is-rounded" @click="close">Cancelar</button>
          </div>
          <div class="control">
            <button class="button button-givu is-rounded" @click="submit">Aplicar</button>
          </div>
        </div>
      </div>
    </div>
    <button class="modal-close is-large" aria-label="close" @click="close"></button>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import {
  TOUCH_OPTIONS,
  OVERALL_STATUS_OPTIONS,
  REJECTION_REASON_OPTIONS
} from '@/lib/funnelOptions'

const EMPTY_FILTERS = {
  filter: '0',
  tradeIn: 'todos',
  funnelTouches: '',
  funnelStatus: '',
  rejectionReason: '',
  zipCode: '',
  region: ''
}

export default {
  name: 'ProductFiltersModal',
  props: {
    close: {
      type: Function,
      default: () => {}
    },
    apply: {
      type: Function,
      default: () => {}
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      touchOptions: TOUCH_OPTIONS,
      overallStatusOptions: OVERALL_STATUS_OPTIONS,
      rejectionReasonOptions: REJECTION_REASON_OPTIONS,
      regionOptions: [],
      draft: {
        ...EMPTY_FILTERS,
        ...Object.keys(EMPTY_FILTERS).reduce((acc, key) => {
          const value = this.filters[key]
          if (value !== undefined && value !== null) acc[key] = String(value)
          return acc
        }, {})
      }
    }
  },
  methods: {
    ...mapActions(['getRegionOptions']),
    async onRegionSearch (query, loading) {
      if (query.length < 2) return
      loading(true)
      this.regionOptions = await this.getRegionOptions(query)
      loading(false)
    },
    clear () {
      this.draft = { ...EMPTY_FILTERS }
    },
    submit () {
      this.apply({ ...this.draft })
      this.close()
    }
  }
}
</script>

<style scoped>
.filters-box {
  max-width: 640px;
  margin: auto;
  padding: 2rem;
  border-radius: 8px;
}
.section-label {
  margin-bottom: 0;
  color: #7a7a7a;
  border-top: 1px solid #f0f0f0;
  padding-top: 12px;
}
.label.is-small {
  font-size: 12px;
  color: #4a4a4a;
}
.modal-background {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
